<template>
  <div>

    <p v-if="message !== null">
      {{message}}
    </p>

    <template v-if="isGroupsVisible">
      <p class="mb-1">
        Количество групп: {{groupAmount | getFormattedNumber}}
      </p>

      <contest-group-previews-table
        v-if="groups.length > 0"
        :contestId="contestId"
        :groups="groups"
        :offset="offset"
        class="mb-4"
      />

      <b-pagination-nav
        v-if="pageAmount > 1"
        :number-of-pages="pageAmount"
        :link-gen="linkGen"
        first-number
        last-number
        use-router
        class="mb-4"
      />
    </template>

    <loading-indicator
      v-if="isLoading"
    />

  </div>
</template>

<script>
import { HTTP } from '../http-common.js';
import notifier from '../notifier.js';

import LoadingIndicator from './LoadingIndicator.vue';
import ContestGroupPreviewsTable from './ContestGroupPreviewsTable.vue';

const PAGE_SIZE = 100;

const LOAD_STATE_INIT          = 1;
const LOAD_STATE_LOADING       = 2;
const LOAD_STATE_LOADED_NORMAL = 3;
const LOAD_STATE_LOADED_ERROR  = 4;

export default {
  name: 'ContestGroups',

  components: {
    LoadingIndicator,
    ContestGroupPreviewsTable,
  },

  props: {
    contestId: {
      type: Number,
      required: true,
    },

    page: {
      type: Number,
      default: 1,
    },
  },

  data() {
    return {
      loadState: LOAD_STATE_INIT,

      /** @type {?number} */
      groupAmount: null,

      /** @type {Array | null} */
      groups: null,
    };
  },

  computed: {
    /** @returns {boolean} */
    isLoading() {
      return this.loadState === LOAD_STATE_LOADING;
    },

    /** @returns {boolean} */
    isLoadedNormal() {
      return this.loadState === LOAD_STATE_LOADED_NORMAL;
    },

    /** @returns {?string} */
    message() {
      if(!this.isLoadedNormal) {
        return null;
      }

      if(this.groupAmount === 0) {
        return 'No groups.';
      }

      return null;
    },

    /** @returns {number} */
    pageAmount() {
      const groupAmount = this.groupAmount;
      if(groupAmount === null) {
        return 0;
      }

      return Math.ceil(groupAmount / PAGE_SIZE);
    },

    /** @returns {number} */
    offset() {
      const prevPageAmount = this.page - 1;
      return prevPageAmount * PAGE_SIZE;
    },

    /** @returns {boolean} */
    isGroupsVisible() {
      const groupAmount = this.groupAmount;
      if(groupAmount === null) {
        return false;
      }

      return groupAmount > 0;
    },
  },

  created() {
    this.loadGroups();
  },

  watch: {
    page() {
      this.loadGroups();
    },
  },

  methods: {
    loadGroups() {
      notifier.deleteSenderNotifications(this);

      this.loadState = LOAD_STATE_LOADING;

      const contestId = this.contestId;
      const url = `/contest/${contestId}/groups`;

      const params = {
        limit: PAGE_SIZE,
      };

      const offset = this.offset;
      if(offset > 0) {
        params.offset = offset;
      }

      HTTP.get(
        url,
        {params: params}
      )
      .then(response => {
        const data = response.data.data;

        if(data === null) {
          this.loadState = LOAD_STATE_LOADED_ERROR;
          notifier.showError('Invalid server response. data === null.', {sender: this});
          return;
        }

        this.groupAmount = data.groupAmount;
        this.groups = data.groups;

        this.loadState = LOAD_STATE_LOADED_NORMAL;
      })
      .catch(err => {
        this.loadState = LOAD_STATE_LOADED_ERROR;
        notifier.showError(err, {sender: this});
      });
    },

    linkGen(pageNum) {
      return pageNum === 1 ? '?' : `?page=${pageNum}`;
    },
  },
};
</script>
